import { createEntityAdapter } from '@reduxjs/toolkit';
import { ClientCrmField } from '../types';

const crmAdapter = createEntityAdapter<ClientCrmField>({
  selectId: crm => crm.localId,
});

export default crmAdapter;
